import {
  DataQuery,
  DBxEvent,
  DomUtil,
  DataValueFormatter,
  InfoViewController
} from "cartovista";
var bb = require("billboard.js").bb;
import "billboard.js/dist/billboard.css";
import {get} from "../appTools/Alerts";
import {exportToPDF} from "../appTools/Print";
import {parseConfig} from "../utils/CvUtils";
import "../../css/BBGraphs.css";


//desactiver ouverture outil d<info lors d'une selection
InfoViewController.prototype._displaySelectedFeaturesInInfoView = function(e) {};

    var bottomPanelBtnHtml = '<span id="BbGraphs_bottomPanel_icon" class="cv-icon"></span>',
        bottomPanelAlertHtml = get("BbGraphs_bottomPanel_alert"),
        bottomPanelContainerHtml = '<div id="BbGraphs_bottomPanel_container" class="BbGraphs_panel_container" data-panel="BOTTOM_PANEL"></div>',
        rightPanelBtnHtml = '<span class="cv-icon cv-icon-chart"></span>',
        rightPanelContainerHtml = '<div id="BbGraphs_rightPanel_container" class="BbGraphs_panel_container" data-panel="RIGHT_PANEL"></div>',
        topPanelContainerHtml = '<div id="BbGraphs_topPanel_container" class="BbGraphs_panel_container" data-panel="TOP_PANEL"></div>',
        printBtnHtml = '<button class="BbGraphs_printBtn easeOut cv-button k-button k-button-icon" data-role="button" role="button" aria-disabled="false" tabindex="-1" title="Exporter le graphique en PDF">' +
                            '<span class="k-sprite cv-icon cv-icon-export"></span>' +
                        '</button>';

    //TODO: Ajout d'un bouton freeze pour ne plus mettre à jour le graphique avec la sélection
    //TODO: Ajuster le btn print (comme dans le panneau légende)
    export default class BbGraphs {
      constructor() {
        this._$bottomPanelBtn = $("#BbGraphs_bottomPanel_btn");
        this._$bottomPanelBtn.html(bottomPanelBtnHtml + (!DomUtil.isResponsiveUI() ? '&nbspDiagrammes': ''));
        this._$bottomPanelContainer = $(bottomPanelContainerHtml);
        $("#BbGraphs_bottomPanel").html(this._$bottomPanelContainer);
        this._$rightPanelBtn = $("#BbGraphs_rightPanel_btn");
        this._$rightPanelBtn.html(rightPanelBtnHtml);
        this._$rightPanelContainer = $(rightPanelContainerHtml);
        $("#BbGraphs_rightPanel").html(this._$rightPanelContainer);
        this._$topPanelContainer = $(topPanelContainerHtml);
        $(".cv-left-top-pane").append(this._$topPanelContainer);
        this._$printBtn = $("#BtnPrint");
        $([this._$bottomPanelContainer[0], this._$rightPanelContainer[0], this._$topPanelContainer[0]]).on("click", ".BbGraphs_printBtn", this._onPrintBtnClicked.bind(this));
        $([this._$bottomPanelContainer[0], this._$rightPanelContainer[0], this._$topPanelContainer[0]]).mouseenter(function(evt) { $(evt.currentTarget).find(".BbGraphs_printBtn").removeClass("easeOut").addClass("easeIn"); }.bind(this));
        $([this._$bottomPanelContainer[0], this._$rightPanelContainer[0], this._$topPanelContainer[0]]).mouseleave(function(evt) { $(evt.currentTarget).find(".BbGraphs_printBtn").removeClass("easeIn").addClass("easeOut"); }.bind(this));
        this._map = window.cartovista.externalInterface.map;
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, _.debounce(this._onThemeSetChanged, 250), this);
        this._map.addEventListener(this._map.EVENTS.ROLLOVER_CHANGED, this._onRolloverChanged, this);
        this._map.addEventListener(this._map.EVENTS.SELECTION_CHANGED, _.debounce(this._onSelectionChanged, 250), this);
        window.cartovista.addEventListener("MasterBtnThemeSetList_onMasterThemeSetChange", _.debounce(this._onThemeSetChanged, 250), this);
        this._mapController = window.cartovista.getMapController(this._map);
        this._activeGraphsConfig = null;
        this._activeMasterTheme = null;
        this._addSplittersResizeListeners();
        //add jquery removed special event used by Constat.js
        $.event.special.removed = {
          remove: function(o) {
            if (o.handler) {
              o.handler();
            }
          }
        }
      }

    //TODO: Permettre plusieurs BbGraphsConfig pour une même thématique (éliminer l'utilisation this._activeGraphsConfig)
    _onThemeSetChanged(evt) {
        if(evt.eventType == "MasterBtnThemeSetList_onMasterThemeSetChange"){
            this._activeMasterTheme = evt.source.masterThemeSet;
        }
        if(typeof evt.source.constructor_event == "undefined"){//create graphs only if its not the constructor of MasterThemeset
            this._clearAllGraphs();
            this._activeGraphsConfig = this._getActiveGraphConfig();
            if (this._activeGraphsConfig) {
                if(this._activeMasterTheme){
                    this._activeGraphsConfig = _.cloneDeep(this._activeGraphsConfig);
                    _.forEach(["TOP_PANEL", "RIGHT_PANEL"], function(panel){
                        if(this._activeGraphsConfig[panel]){
                            _.forEach(["TABS", "SLIDES"], function(tabOrSlide){
                                if(this._activeGraphsConfig[panel][tabOrSlide]){
                                    _.forEach(this._activeGraphsConfig[panel][tabOrSlide], function(configs){
                                        this._changeConfigs(configs);
                                    }.bind(this));
                                }
                            }.bind(this));
                            if(this._activeGraphsConfig[panel].GRAPHS){
                                this._changeConfigs(this._activeGraphsConfig[panel]);
                            }
                        }
                    }.bind(this));
                }
                _.delay(function(){this._generateAllPanels();}.bind(this), 0)
            }
        }
    };

    _changeConfigs(configs){
        if(configs.TITLE) configs.TITLE = parseConfig({TITLE: configs.TITLE}, {VALUE: this._activeMasterTheme.id, TEXT: this._activeMasterTheme.themesText}).TITLE;
        _.forEach(configs.GRAPHS, function(graphConfigs){
            if(graphConfigs.DATA_SOURCES) graphConfigs.DATA_SOURCES = parseConfig(graphConfigs.DATA_SOURCES, {VALUE: this._activeMasterTheme.id, TEXT: this._activeMasterTheme.themesText});
            if(graphConfigs.TITLE) graphConfigs.TITLE = parseConfig({TITLE: graphConfigs.TITLE}, {VALUE: this._activeMasterTheme.id, TEXT: this._activeMasterTheme.themesText}).TITLE;
        }.bind(this));
    }

    _onRolloverChanged(evt) {
        var activeLayer = evt.source;
        var graphInstances = _.filter(bb.instance, {"activeLayer": activeLayer});
        if (activeLayer._rolloverFeatures && activeLayer._rolloverFeatures.length) {
            new DataQuery([activeLayer.featureNameDataColumn], _.map(activeLayer._rolloverFeatures, "id"))
                .execute(function(result) {
                    var xDataValues = result.values[activeLayer.featureNameDataColumn.dataTable.id][activeLayer.featureNameDataColumn.id];
                    _.forEach(graphInstances, function(graphInstance) {
                        var $graphInstanceElem = $(graphInstance.element);
                        if ($graphInstanceElem.is(":visible")) {
                            if (graphInstance.config("data.type") != "line") {
                                var excludedClasses = _.reduce(xDataValues, function(excludedClasses, xDataValue) {
                                    var idx = graphInstance.categories().indexOf(xDataValue)
                                    if (idx > -1) {
                                        excludedClasses.push(".bb-shape-" + idx);
                                    }
                                    return excludedClasses;
                                }, []).join(", ");
                                $graphInstanceElem.find(".bb-chart-bars .bb-shape").css("fill-opacity", 1);
                                $graphInstanceElem.find(".bb-chart-bars .bb-shape" + (excludedClasses.length ? ":not(" + excludedClasses + ")" : "")).css("fill-opacity", 0.1);
                            } else {
                                graphInstance.focus(xDataValues);
                            }
                        }
                    });
                }, this);
        } else {
            _.forEach(graphInstances, function(graphInstance) {
                var $graphInstanceElem = $(graphInstance.element);
                if ($graphInstanceElem.is(":visible")) {
                    if (graphInstance.config("data.type") != "line") {
                        $graphInstanceElem.find(".bb-chart-bars .bb-shape").css("fill-opacity", 1);
                    } else {
                        graphInstance.revert();
                    }
                }
            });
        }
    };

    _onSelectionChanged(evt) {
        var activeLayer = evt.source;
        var graphInstances = _.filter(bb.instance, {"activeLayer": activeLayer});
        _.forEach(graphInstances, function(graphInstance) {
            var graphId = graphInstance.id,
                graphConfig = graphInstance.graphConfig,
                $panelContainer = graphInstance.$panelContainer,
                $graphDiv = $panelContainer.find("#" + graphInstance.id);
            $graphDiv.replaceWith($graphDiv.clone());
            graphInstance.destroy();
            var panel = window.cartovista.getUIController(this._map).findInstance($panelContainer.parent().attr("id"));
            if(panel){
                if (panel.isActive) this._generateGraph(graphConfig, graphId, $panelContainer);
                else {
                    panel.addOneTimeEventListener(panel.EVENTS.ACTIVATED, this._generateGraph.bind(this, graphConfig, graphId, $panelContainer), this);
                }
            }
        }.bind(this));
    };

    _getActiveGraphConfig() {
        if (this._map.activeThemeSet) {
            return _.find(C.PANELS.BB_GRAPHS, function(graphConfig) {
                return graphConfig.THEMESETS_IDS.indexOf(this._map.activeThemeSet.id) > -1;
            }.bind(this));
        } else {
            return null;
        }
    };

    _clearAllGraphs() {
        while (bb.instance.length) {
            bb.instance[0].destroy();
        };
        this._$bottomPanelContainer.empty();
        this._$rightPanelContainer.empty();
        this._$topPanelContainer.empty();

        var _bottomPanel = window.cartovista.getUIController(this._map).findInstance("BbGraphs_bottomPanel")
        if(_bottomPanel) {;
            _bottomPanel.removeEventListener(_bottomPanel.EVENTS.ACTIVATED, this._bottomPanelActivated, this);
            _bottomPanel.removeEventListener(_bottomPanel.EVENTS.ACTIVATED, this._generateGraph.bind(null, null, null), this);
        }
        var _rightPanel = window.cartovista.getUIController(this._map).findInstance("BbGraphs_rightPanel");
        if(_rightPanel) {
            _rightPanel.removeEventListener(_rightPanel.EVENTS.ACTIVATED, this._rightPanelActivated, this);
            _rightPanel.removeEventListener(_rightPanel.EVENTS.ACTIVATED, this._generateGraph.bind(null, null, null), this);
        }

    };

    _generateAllPanels() {
        if (typeof this._activeGraphsConfig.TOP_PANEL != "undefined") {
            this._$topPanelContainer.show();
            this._generatePanel(this._$topPanelContainer, this._activeGraphsConfig.TOP_PANEL);
            this._$printBtn.prop("disabled", true).addClass("k-state-disabled");
        } else {
            this._$topPanelContainer.hide();
            this._$printBtn.prop("disabled", "").removeClass("k-state-disabled");
        }
        if (typeof this._activeGraphsConfig.BOTTOM_PANEL != "undefined") {
            var _bottomPanel = window.cartovista.getUIController(this._map).findInstance("BbGraphs_bottomPanel");
            if(_bottomPanel) {
                if(_bottomPanel.isActive) this._bottomPanelActivated();
                else _bottomPanel.addOneTimeEventListener(_bottomPanel.EVENTS.ACTIVATED, this._bottomPanelActivated, this);
            }
            this._$bottomPanelBtn.prop("disabled", "").removeClass("k-state-disabled");
        } else {
            var _bottomPanel = window.cartovista.getUIController(this._map).findInstance("BbGraphs_bottomPanel");
            if(_bottomPanel) {
                _bottomPanel.deactivate();
                //_bottomPanel.removeEventListener(_bottomPanel.EVENTS.ACTIVATED, this._bottomPanelActivated, this);
            }
            this._$bottomPanelBtn.prop("disabled", true).addClass("k-state-disabled");
        }
        if (typeof this._activeGraphsConfig.RIGHT_PANEL != "undefined") {
            var _rightPanel = window.cartovista.getUIController(this._map).findInstance("BbGraphs_rightPanel");
            if(_rightPanel) {
                if(_rightPanel.isActive) this._rightPanelActivated();
                else _rightPanel.addOneTimeEventListener(_rightPanel.EVENTS.ACTIVATED, this._rightPanelActivated, this);
            }
            this._$rightPanelBtn.prop("disabled", "").removeClass("k-state-disabled");
            
        } else {
            var _rightPanel = window.cartovista.getUIController(this._map).findInstance("BbGraphs_rightPanel");
            if(_rightPanel) {
                _rightPanel.deactivate();
                //_rightPanel.removeEventListener(_rightPanel.EVENTS.ACTIVATED, this._rightPanelActivated, this);
            }
            this._$rightPanelBtn.prop("disabled", true).addClass("k-state-disabled");
        }
    };

    _rightPanelActivated() {
        this._generatePanel(this._$rightPanelContainer, this._activeGraphsConfig.RIGHT_PANEL);
    };

    _bottomPanelActivated() {
        this._generatePanel(this._$bottomPanelContainer, this._activeGraphsConfig.BOTTOM_PANEL);
    };

    _generatePanel($panelContainer, graphsConfig) {
        //graphs are generated inside carousel slides
        if (typeof graphsConfig.SLIDES != "undefined") {
            this._generateSlides($panelContainer, graphsConfig);
        }
        //graphs are generated inside nav tabs
        if (typeof graphsConfig.TABS != "undefined") {
            this._generateTabs($panelContainer, graphsConfig);
        }
        //graphs are generated directly in the panel container
        if (typeof graphsConfig.GRAPHS != "undefined") {
            this._generatePlainPanel($panelContainer, graphsConfig);
        }
    };

    //permet de générer les graphiques dans des nav tabs
    _generateTabs($panelContainer, graphsConfig) {
        var activeGraphsConfigId = this._activeGraphsConfig.ID,
            panelId = $panelContainer.attr("data-panel");
        $panelContainer.html('<div>' +
                                (!DomUtil.isIE() ? printBtnHtml : "") +
                                '<ul id="BbGraphs_navTabs_' + panelId + '" class="nav nav-tabs" role="tablist"></ul>' +
                                '<div id="BbGraphs_tabContent_' + panelId + '" class="tab-content"></div>' +
                            '</div>');
        _.forEach(graphsConfig.TABS, function(tabConfig, tabIdx) {
            var navTabId = ["BbGraphs", activeGraphsConfigId, panelId, "NAV_TAB", tabIdx].join("_"),
                tabPaneId = ["BbGraphs", activeGraphsConfigId, panelId, "TAB", tabIdx].join("_");
            $panelContainer.find("#BbGraphs_navTabs_" + panelId).append(
                '<li class="nav-item" role="presentation">' +
                    '<a class="nav-link ' + (tabIdx == 0 ? "active" : "") + '" id="' + navTabId + '" href="#' + tabPaneId + '" aria-controls="' + tabPaneId + '" role="tab" data-bs-toggle="tab">' + tabConfig.BUTTON_TITLE + '</a>' +
                '</li>'
            );
            $panelContainer.find("#BbGraphs_tabContent_" + panelId).append(
                '<div role="tabpanel" class="tab-pane ' + (tabIdx == 0 ? 'active' : '') + '" id="' + tabPaneId + '">' +
                    _.map(tabConfig.GRAPHS, function(graphConfig, graphIdx) {
                        var graphId = [tabPaneId, "GRAPH", graphIdx].join("_");
                        return '<div class="BbGraphs_printable page-header" ' + (graphIdx != 0 ? 'print-forcePageBreak-before="true"' : '' ) + '>' +
                                    '<h5 class="text-center"><small>' + graphConfig.TITLE + '</small></h5>' +
                                '</div>' +
                                '<div id="' + graphId + '" class="BbGraphs_printable" print-svg="true" ' + (this._activeGraphsConfig.SOURCE ? 'print-append="' + escape(this._activeGraphsConfig.SOURCE) + '"' : '') + '></div>'
                    }.bind(this)).join("") +
                '</div>'
            );

            //bind tab events listeners for Constat.js
            $panelContainer.find("#" + navTabId)[0].addEventListener("show.bs.tab", function() {
                console.log("tabPaneShown:", tabPaneId);
                window.cartovista.dispatchEvent(new DBxEvent("BbGraphs_onTabShow", {"tabPaneId": tabPaneId}));
            });
            $panelContainer.find("#" + navTabId).on("removed", function() {
                window.cartovista.dispatchEvent(new DBxEvent("BbGraphs_onTabShowRemoved", {"tabPaneId": tabPaneId}));
            });

            //generate graphs displayed on the first tab
            if (tabIdx == 0) {
                _.forEach(tabConfig.GRAPHS, function(graphConfig, graphIdx) {
                    var graphId = [tabPaneId, "GRAPH", graphIdx].join("_"),
                        graphConfig = _.defaults({}, graphConfig, graphsConfig.DEFAULTS);
                    this._generateGraph(graphConfig, graphId, $panelContainer);
                }.bind(this));
                //dispatchEvent for Constat.js
                console.log("tabPaneShown:", tabPaneId);
                window.cartovista.dispatchEvent(new DBxEvent("BbGraphs_onTabShow", {"tabPaneId": tabPaneId}));
            } else {
                //generate graphs when tab is shown
                $panelContainer.find("#" + navTabId)[0].addEventListener("show.bs.tab", function() {
                    _.forEach(tabConfig.GRAPHS, function(graphConfig, graphIdx) {
                        var graphId = [tabPaneId, "GRAPH", graphIdx].join("_"),
                            graphConfig = _.defaults({}, graphConfig, graphsConfig.DEFAULTS);
                        this._generateGraph(graphConfig, graphId, $panelContainer);
                    }.bind(this));
                }.bind(this), {once : true});
            }
        }.bind(this));
    };

    _generateGraphRow(slideItemId, graphs, nb){
        return '<div class="row">' +
            _.map(graphs, function(graphConfig, graphIdx) {
                var graphId = [slideItemId, "GRAPH", graphIdx + nb].join("_");
                return '<div class="BbGraphs_column col-md-' + (12 / graphs.length) + '" style="padding:0;">' +
                            '<div class="BbGraphs_printable page-header" ' + (graphIdx != 0 ? 'print-forcePageBreak-before="true"' : '' ) + '>' +
                                '<h5 class="text-center"><strong>' + graphConfig.TITLE + '</strong></h5>' +
                            '</div>' +
                            '<div id="' + graphId + '" class="BbGraphs_printable" print-svg="true" ' + (this._activeGraphsConfig.SOURCE ? 'print-append="' + escape(this._activeGraphsConfig.SOURCE) + '"' : '') + '></div>' +
                        '</div>';
            }.bind(this)).join("") +
        '</div>';
    }

    //permet de générer les graphiques dans des slides d'un carousel
    _generateSlides($panelContainer, graphsConfig) {
        var activeGraphsConfigId = this._activeGraphsConfig.ID,
            panelId = $panelContainer.attr("data-panel");
        $panelContainer.html('<div id="BbGraphs_carousel_' + panelId + '" class="carousel carousel-dark slide">' +
                                (graphsConfig.SLIDES.length > 1 ? '<ol class="carousel-indicators"></ol>' : '') +
                                '<div class="carousel-inner"></div>' +
                                (!DomUtil.isIE() ? printBtnHtml : "") +
                                (graphsConfig.SLIDES.length > 1 ? 
                                '<button class="carousel-control-prev" type="button" data-bs-target="#BbGraphs_carousel_' + panelId + '" data-bs-slide="prev" title="Diapositive précédente">' +
                                  '<span class="carousel-control-prev-icon"></span>' +
                                '</button>' +
                                '<button class="carousel-control-next" type="button" data-bs-target="#BbGraphs_carousel_' + panelId + '" data-bs-slide="next" title="Diapositive suivante">' +
                                  '<span class="carousel-control-next-icon"></span>' +
                                '</button>' : '') +
                            '</div>');
        _.forEach(graphsConfig.SLIDES, function(slideConfig, slideIdx) {
            var slideItemId = ["BbGraphs", activeGraphsConfigId, panelId, "SLIDE", slideIdx].join("_");
            if (!DomUtil.isResponsiveUI()) {
                var nbRow = 1;
                if(slideConfig.GRAPHS.length == 3){
                    nbRow = 2;
                }
                else if (slideConfig.FORCE_VERTICAL && slideConfig.GRAPHS.length === 2) {
                    // Votre nouvel indicateur pour le cas "2 graphs = 2 rows"
                    nbRow = 2;
                } 
                else {
                    while(slideConfig.GRAPHS.length / nbRow > 3){
                        nbRow++;
                    }
                }
            } else var nbRow = slideConfig.GRAPHS.length;
            var nbCol = Math.floor(slideConfig.GRAPHS.length / nbRow);
            $panelContainer.find(".carousel-indicators").append('<button type="button" data-bs-target="#BbGraphs_carousel_' + panelId + '" data-bs-slide-to="' + slideIdx + '" class="' + (slideIdx == 0 ? 'active' : '') + '" ' + (slideIdx == 0 ? 'aria-current="true"' : '') + ' aria-label="Diapositive ' + (slideIdx + 1) + '"></button>');
            $panelContainer.find(".carousel-inner").append(
                '<div id="' + slideItemId + '" class="carousel-item ' + (slideIdx == 0 ? 'active' : '') + '">' +
                    '<div class="BbGraphs_printable BbGraphs_slideItem_title">' +
                        '<h4 class="text-center"><strong>' + slideConfig.TITLE + '</strong></h4>' +
                    '</div>' +
                    _.map(Array(nbRow), function(val, idx){
                        if(idx == nbRow - 1 && (idx * nbCol) + _.slice(slideConfig.GRAPHS, idx * nbCol, nbCol + idx * nbCol).length !== slideConfig.GRAPHS.length){
                            return this._generateGraphRow(slideItemId, _.slice(slideConfig.GRAPHS, idx * nbCol), idx * nbCol);
                        } else{
                            return this._generateGraphRow(slideItemId, _.slice(slideConfig.GRAPHS, idx * nbCol, nbCol + idx * nbCol), idx * nbCol);
                        }
                    }.bind(this)).join("") +
                    (slideConfig.SUBTITLE ? '<div class="BbGraphs_printable BbGraphs_slideItem_subtitle"><h6 class="text-center">' + slideConfig.SUBTITLE + '</h6></div>' : "") +
                '</div>'
            );

            //generate graphs displayed on the first slide
            if (slideIdx == 0) {
                _.forEach(slideConfig.GRAPHS, function(graphConfig, graphIdx) {
                    var graphId = [slideItemId, "GRAPH", graphIdx].join("_"),
                        graphConfig = _.defaults({}, graphConfig, graphsConfig.DEFAULTS);
                    this._generateGraph(graphConfig, graphId, $panelContainer);
                }.bind(this));
                //dispatchEvent for Constat.js
                console.log("slideItemShown:", slideItemId);
                window.cartovista.dispatchEvent(new DBxEvent("BbGraphs_onCarouselSlide", {"slideItemId": slideItemId}));
            }

            //on carousel slid.bs.carousel event is triggered if its slide is the evt.relatedTarget
            $panelContainer.find(".carousel")[0].addEventListener("slide.bs.carousel", function(evt) {
                if (evt.relatedTarget.id == slideItemId) {
                    _.forEach(slideConfig.GRAPHS, function(graphConfig, graphIdx) {
                        var graphId = [slideItemId, "GRAPH", graphIdx].join("_");
                        //generate graphs if not already generated
                        if (!_.find(bb.instance, {"id": graphId})) {
                            var graphConfig = _.defaults({}, graphConfig, graphsConfig.DEFAULTS);
                            this._generateGraph(graphConfig, graphId, $panelContainer);
                        }
                    }.bind(this));
                    //dispatchEvent for Constat.js
                    console.log("slideItemShown:", slideItemId);
                    window.cartovista.dispatchEvent(new DBxEvent("BbGraphs_onCarouselSlide", {"slideItemId": slideItemId}));
                }
            }.bind(this));
            //bind tab event listener for Constat.js
            $panelContainer.find("#" + slideItemId).on("removed", function() {
                window.cartovista.dispatchEvent(new DBxEvent("BbGraphs_onCarouselSlideRemoved", {"slideItemId": slideItemId}));
            });

        }.bind(this));
    };

    //permet de générer les graphiques directement dans le panel container
    _generatePlainPanel($panelContainer, graphsConfig) {
        var activeGraphsConfigId = this._activeGraphsConfig.ID,
            panelId = $panelContainer.attr("data-panel");
        _.forEach(graphsConfig.GRAPHS, function(graphConfig) {
            $panelContainer.html('<div class="' + (panelId != "RIGHT_PANEL" ? "container-fluid" : "") + '">' +
                _.map(graphsConfig.GRAPHS, function(graphConfig, graphIdx) {
                    var graphId = ["BbGraphs", activeGraphsConfigId, panelId, "GRAPH", graphIdx].join("_");
                    return '<div class="BbGraphs_column ' + (panelId != "RIGHT_PANEL" ? "col-md-" + (12 / graphsConfig.GRAPHS.length) : "") + '" style="padding:0;">' +
                                '<div class="page-header">' +
                                    '<h5 class="text-center"><small>' + graphConfig.TITLE + '</small></h5>' +
                                '</div>' +
                                '<div id="' + graphId + '"></div>' +
                            '</div>';
                }).join("") +
                (!DomUtil.isIE() ? printBtnHtml : "") +
            '</div>');
        }.bind(this));
        //generate graphs immediately
        _.forEach(graphsConfig.GRAPHS, function(graphConfig, graphIdx) {
            var graphId = ["BbGraphs", activeGraphsConfigId, panelId, "GRAPH", graphIdx].join("_"),
                graphConfig = _.defaults({}, graphConfig, graphsConfig.DEFAULTS);
            this._generateGraph(graphConfig, graphId, $panelContainer);
        }.bind(this));
    };

    _generateGraph(graphConfig, graphId, $panelContainer) {
        console.time("generateGraph " + graphId);
        return this._getGraphData(graphConfig).then(function(graphData) {
            var graph = this._generateBbGraphInstance(graphConfig, $panelContainer, graphId, graphData.graphData, graphData.graphDataRows);
            if (graph.$panelContainer.attr("data-panel") == "BOTTOM_PANEL") {
                if (!graph.data().length) {
                    graph.$.chart.append("div").html($(bottomPanelAlertHtml).addClass("show")[0].outerHTML);
                } 
            }
            console.timeEnd("generateGraph " + graphId);
            return graph;
        }.bind(this)).catch(function(error) {
            console.error(error);
        });
    };

    _getGraphData(graphConfig) {
        return Promise.all(_.map(graphConfig.DATA_SOURCES, function(dataSourceConfig) {
            return this._queryDataSource(dataSourceConfig).then(function(queryResult) {
                return _.reduce(queryResult.dataQuery.dataColumns, function(result, dataColumn, idx) {
                    //replace featureNameDataColumn values by dataSourceConfig.FEATURES_DATA_IDS
                    if (idx == 0 && typeof dataSourceConfig.FEATURES_DATA_IDS != "undefined") {
                        result.rowsDatacolumn.push(dataSourceConfig.FEATURES_DATA_IDS);
                        result.rowsDataset.push(dataSourceConfig.FEATURES_DATA_IDS);
                    } else {
                        result.rowsDatacolumn.push(dataColumn);
                        result.rowsDataset.push(queryResult.values[dataColumn.dataTable.id][dataColumn.id]);
                    }
                    return result;
                }, {rowsDataset: [], rowsDatacolumn: []});
            }.bind(this));
        }.bind(this))).then(function(result) {
            var rowsDataset = _.map(result, "rowsDataset");
            var rowsDatacolumn = _.map(result, "rowsDatacolumn");
            if(graphConfig.GRAPH_TYPE != "pie"){
                rowsDataset.unshift(_.map(_.concat(["x"], graphConfig.X_DATA_NAMES), _.castArray));
                rowsDatacolumn.unshift(_.map(_.concat(["x"], graphConfig.X_DATA_NAMES), _.castArray));
            } else{
                rowsDataset.unshift(_.map(graphConfig.X_DATA_NAMES, _.castArray));
                rowsDatacolumn.unshift(_.map(graphConfig.X_DATA_NAMES, _.castArray));
            }
            var graphData = _.map(_.zip.apply(_, rowsDataset), _.flatten);
            var graphDatacolum = _.map(_.zip.apply(_, rowsDatacolumn), _.flatten);
            //enlève les features si toutes les données sont null
            //graphConfig.GRAPH_TYPE != "pie" la tete doit etre le nom
            var graphDataRows = graphDatacolum;
            var graphData = _.map(graphData, function(values, index) {
                return _.filter(values, function(value, idx) {
                    if(graphConfig.GRAPH_TYPE != "pie"){
                        return _.some(_.tail(graphData), function(values) {
                            return values[idx] !== null;
                        });
                    } else{
                        return _.some(graphData, function(values) {
                            return values[idx] !== null;
                        });
                    }
                });
            });
            return graphConfig.DATA_AUTO_SORT ? {graphData : this._sortGraphData(graphData, graphConfig.DATA_AUTO_SORT, 1), graphDataRows: graphDataRows} : {graphData : graphData, graphDataRows: graphDataRows};
        }.bind(this));
    };

    _queryDataSource(dataSourceConfig) {
        return new Promise(function(resolve, reject) {
            var layer = this._map.getLayer(dataSourceConfig.LAYER_ID),
                dataTable = layer.getDataTable(dataSourceConfig.DATATABLE_ID),
                //featureNameDataColumn doit être dans la même dataTable que les DATACOLUMNS_IDS si certaines features ne sont pas dans le fichier Excel (voir bug SUPPORT-474)
                dataColumns = (typeof dataSourceConfig.GET_FEATURE_NAME_DATACOLUMN != "undefined" && !dataSourceConfig.GET_FEATURE_NAME_DATACOLUMN) ? dataTable.getDataColumns(dataSourceConfig.DATACOLUMNS_IDS) : _.concat([layer.featureNameDataColumn], dataTable.getDataColumns(dataSourceConfig.DATACOLUMNS_IDS));
            if(layer.selectionStack.length){
                layer.computeSelectionStack(function(linkingIds){
                    var featuresIds = typeof dataSourceConfig.FEATURES_IDS != "undefined" ? dataSourceConfig.FEATURES_IDS : layer.selectionStack.length ? linkingIds : dataSourceConfig.NO_SELECTION_SHOW_ALL_FEATURES === true ? null : [];
                    new DataQuery(dataColumns, featuresIds).execute(resolve, this, true);
                });
            } else{
                var featuresIds = typeof dataSourceConfig.FEATURES_IDS != "undefined" ? dataSourceConfig.FEATURES_IDS : dataSourceConfig.NO_SELECTION_SHOW_ALL_FEATURES === true ? null : [];
                new DataQuery(dataColumns, featuresIds).execute(resolve, this, true);
            }
        }.bind(this));
    };

    _sortGraphData(graphData, sortOrder, sortByRowIdx) {
        var data = _.map(graphData, _.tail),
            sortedData = _.zip.apply(_, _.orderBy(_.zip.apply(_, data), // Tri intelligent prenant en compte null
                [
                    (row) => row[sortByRowIdx] === null ? (sortOrder === 'asc' ? -1 : 1) : 0, // Place null en premier (asc) ou dernier (desc)
                    (row) => isNaN(row[sortByRowIdx]) ? row[sortByRowIdx] : parseFloat(row[sortByRowIdx]) // Trie ensuite nombres et textes
                ], 
                ['asc', sortOrder] // Ordre du tri
            ));
        _.forEach(sortedData, function(d, idx) {  d.unshift(graphData[idx][0]); });
        return sortedData;
    };

    _generateBbGraphInstance(graphConfig, $panelContainer, graphId, graphData, graphDataRows) {
        var graphConfigCloned = _.cloneDeep(graphConfig);
        var graph = bb.generate({
            "bindto": $panelContainer.find("#" + graphId)[0],
            "padding": graphConfig.PADDING,
            "size": {
                "height": graphConfig.HEIGHT_FN(),
                "width": graphConfig.WIDTH_FN()
            },
            "data": {
                "x": graphConfig.GRAPH_TYPE != "pie" ? "x" : undefined,
                "columns": graphConfig.GRAPH_DATA_ORIENTATION == "columns" ? graphData : undefined,
                "rows": graphConfig.GRAPH_DATA_ORIENTATION == "rows" ? graphData : undefined,
                "type": graphConfig.GRAPH_TYPE,
                "types": graphConfig.DATA_TYPES,
                "names": graphConfig.DATA_NAMES,
                "colors": graphConfig.DATA_COLORS,
                "classes": graphConfig.DATA_CLASSES,
                "groups": graphConfig.STACK_GROUPS,
                "order": graphConfig.STACK_ORDER,
                "regions": typeof graphConfig.DATA_LINE_CHART_REGIONS != "undefined" ? graphConfig.DATA_LINE_CHART_REGIONS : undefined,
                "selection": {
                    "grouped": typeof graphConfig.STACK_GROUPS != "undefined" ? true : false
                },
                "labels": typeof graphConfig.DATA_LABELS != "undefined" ? graphConfig.DATA_LABELS : false,
                "axes": typeof graphConfig.DATA_AXES != "undefined" ? graphConfig.DATA_AXES : {},
                "onover": function(d) {
                    if (typeof graphConfig.DATA_ON_OVER_FN != "undefined") { graphConfig.DATA_ON_OVER_FN(d, graph); }
                    this._onGraphDataOver(d, graph);
                }.bind(this),
                "onout": function(d) {
                    if (typeof graphConfig.DATA_ON_OUT_FN != "undefined") { graphConfig.DATA_ON_OUT_FN(d, graph); }
                    this._onGraphDataOut(d, graph);
                }.bind(this),
                "onclick": function(d, element) {
                    if (typeof graphConfig.DATA_ON_CLICK_FN != "undefined") { graphConfig.DATA_ON_CLICK_FN(d, element, graph); }
                    this._onGraphDataClick(d, element, graph);
                }.bind(this),
            },
            "axis": {
                "x": {
                    "type": "category", //only category x type is supported
                    "clipPath" : typeof graphConfig.X_AXIS_CLIP_PATH != "undefined" ? graphConfig.X_AXIS_CLIP_PATH : true,
                    "tick": {
                        "centered": true,
                        "culling": false,
                        "values": typeof graphConfig.X_AXIS_TICK_VALUES != "undefined" ? graphConfig.X_AXIS_TICK_VALUES : null,
                        "width": typeof graphConfig.X_AXIS_TICK_WIDTH != "undefined" ? graphConfig.X_AXIS_TICK_WIDTH : 100,
                        "rotate" : typeof graphConfig.X_AXIS_TICK_ROTATE != "undefined" ? graphConfig.X_AXIS_TICK_ROTATE : 0,
                        "text": {
                            "position":  typeof graphConfig.X_AXIS_TICK_TEXT_POSITION != "undefined" ? graphConfig.X_AXIS_TICK_TEXT_POSITION : {x: 0, y: 0},
                        }
                    },
                    "label":  graphConfig.X_AXIS_LABEL,
                    "show": typeof graphConfig.SHOW_X_AXIS != "undefined" ? graphConfig.SHOW_X_AXIS : true,
                },
                "y": {
                    "min": graphConfig.Y_AXIS_MIN_VALUE,
                    "max": graphConfig.Y_AXIS_MAX_VALUE,
                    "padding": graphConfig.Y_AXIS_PADDING,
                    "label": graphConfig.Y_AXIS_LABEL,
                    "show": typeof graphConfig.SHOW_Y_AXIS != "undefined" ? graphConfig.SHOW_Y_AXIS : true,
                    "tick": {
                        "culling": typeof graphConfig.Y_AXIS_TICK_CULLING != "undefined" ? graphConfig.Y_AXIS_TICK_CULLING : false,
                        "format": typeof graphConfig.Y_AXIS_TICK_FORMAT_FN != "undefined" ? function(value) { return graphConfig.Y_AXIS_TICK_FORMAT_FN(value, graph); } : undefined,
                    }
                },
                "y2": {
                    "min": graphConfig.Y2_AXIS_MIN_VALUE,
                    "max": graphConfig.Y2_AXIS_MAX_VALUE,
                    "padding": graphConfig.Y2_AXIS_PADDING,
                    "label": graphConfig.Y2_AXIS_LABEL,
                    "show": typeof graphConfig.SHOW_Y2_AXIS != "undefined" ? graphConfig.SHOW_Y2_AXIS : false,
                },
                "rotated": typeof graphConfig.AXIS_ROTATED != "undefined" ? graphConfig.AXIS_ROTATED : null,
            },
            "regions": typeof graphConfig.CHART_REGIONS != "undefined" ? graphConfig.CHART_REGIONS : undefined,
            "grid": {
                "x": {
                    "lines": graphConfig.X_GRID_LINES,
                    "show": graphConfig.X_GRID
                },
                "y": {
                    "lines": graphConfig.Y_GRID_LINES,
                    "show": graphConfig.Y_GRID
                }
            },
            "pie": graphConfig.GRAPH_TYPE == "pie" ? graphConfig.PIE_OPTIONS : undefined,
            "tooltip": {
                "format": {
                    "title": typeof graphConfig.TOOLTIP_TITLE_FN != "undefined" ? function(x) { return graphConfig.TOOLTIP_TITLE_FN(x, graph); } : undefined,
                    "name": typeof graphConfig.TOOLTIP_NAME_FN != "undefined" ? function(name, ratio, id, index) { return graphConfig.TOOLTIP_NAME_FN(name, ratio, id, index, graph); } : undefined,
                    "value": typeof graphConfig.TOOLTIP_VALUE_FN != "undefined" ? function(value, ratio, id, index) { return graphConfig.TOOLTIP_VALUE_FN(value, ratio, id, index, graph); } : function(value, ratio, id, index){ return this._createTooltip(value, ratio, id, index, graphConfig, graphData, graphDataRows)}.bind(this),
                },
                "onshow": typeof graphConfig.TOOLTIP_ON_SHOW_FN != "undefined" ? function() { graphConfig.TOOLTIP_ON_SHOW_FN(graph); } : undefined,
                "onshown": typeof graphConfig.TOOLTIP_ON_SHOWN_FN != "undefined" ? function() { graphConfig.TOOLTIP_ON_SHOWN_FN(graph); } : undefined,
                "onhide": typeof graphConfig.TOOLTIP_ON_HIDE_FN != "undefined" ? function() { graphConfig.TOOLTIP_ON_HIDE_FN(graph); } : undefined,
                "onhidden": typeof graphConfig.TOOLTIP_ON_HIDDEN_FN != "undefined" ? function() { graphConfig.TOOLTIP_ON_HIDDEN_FN(graph); } : undefined
            },
            "legend": {
                "show": graphConfig.SHOW_LEGEND,
                "hide": typeof graphConfig.HIDE_LEGEND != "undefined" ? graphConfig.HIDE_LEGEND : false,
                "position": graphConfig.LEGEND_POSITION,
                "inset": graphConfig.LEGEND_INSET,
                "item": {
                    "onover": function(id) {
                        if (typeof graphConfig.LEGEND_ON_OVER_FN != "undefined") { graphConfig.LEGEND_ON_OVER_FN(id, graph); }
                        this._onGraphLegendOver(id, graph);
                    }.bind(this),
                    "onout": function(id) {
                        if (typeof graphConfig.LEGEND_ON_OUT_FN != "undefined") { graphConfig.LEGEND_ON_OUT_FN(id, graph); }
                        this._onGraphLegendOut(id, graph);
                    }.bind(this),
                    "onclick": function(id) {
                        if (typeof graphConfig.LEGEND_ON_CLICK_FN != "undefined") { graphConfig.LEGEND_ON_CLICK_FN(id, graph); }
                        this._onGraphLegendClick(id, graph, graphConfig);
                    }.bind(this)
                },
            },
            "oninit": typeof graphConfig.ON_INIT_FN != "undefined" ? function() { graphConfig.ON_INIT_FN(graph); } : undefined,
            "onrendered": typeof graphConfig.ON_RENDERED_FN != "undefined" ? function() { setTimeout(function() { graphConfig.ON_RENDERED_FN(graph); },0); } : undefined,
            "onresized": typeof graphConfig.ON_RESIZED_FN != "undefined" ? function() { graphConfig.ON_RESIZED_FN(graph); } : undefined
        });

        graph.id = graphId;
        graph.graphData = graphData;
        graph.$panelContainer = $panelContainer;
        graph.graphConfig = graphConfigCloned;
        graph.activeLayer = this._map.getLayer(graphConfig.ACTIVE_LAYER_ID);
        return graph;
    };

    _createTooltip(value, ratio, id, index, graphConfig, graphData, graphDataRows) {
        var xIndex = _.indexOf(graphData[0], id);
        var yIndex = index + 1;
        var dataColumn;
        if(graphDataRows[yIndex] && graphDataRows[yIndex][xIndex]) dataColumn = graphDataRows[yIndex][xIndex];
        else dataColumn = graphDataRows[1][1];
        return DataValueFormatter.formatValue(value, dataColumn, null, null, true);
    };

    //TODO: Prendre en considération les autres types de graphiques (area, donut, pie, step, etc...)
    _onGraphDataOver(d, graph) {
        if (graph.config("data.type") != "line") {
            var xDataValue = graph.categories()[d.x];
            _.forEach(bb.instance, function(graphInstance) {
                var $graphInstanceElem = $(graphInstance.element);
                if ($graphInstanceElem.is(":visible")) {
                    if (graphInstance.config("data.type") != "line" ) {
                        var idx = graphInstance.categories().indexOf(xDataValue);
                        $graphInstanceElem.find(".bb-chart-bars .bb-shape:not(.bb-shape-" + idx + ")").css("fill-opacity", 0.1);
                        $graphInstanceElem.find(".bb-chart-bars .bb-shape-" + idx).css("fill-opacity", 1);
                        $graphInstanceElem.find(".bb-chart-lines .bb-circle-" + idx).attr("r", 4);
                    } else {
                        graphInstance.focus(xDataValue);
                    }
                }
            });
            this._setActiveLayerRollover(xDataValue, graph);
        }
    };

    _onGraphDataOut(d, graph) {
        if (graph.config("data.type") != "line") {
            var xDataValue = graph.categories()[d.x];
            _.forEach(bb.instance, function(graphInstance) {
                var $graphInstanceElem = $(graphInstance.element);
                if ($graphInstanceElem.is(":visible")) {
                    if (graphInstance.config("data.type") != "line" ) {
                        var idx = graphInstance.categories().indexOf(xDataValue);
                        $graphInstanceElem.find(".bb-chart-bars .bb-shape").css("fill-opacity", 1);
                        $graphInstanceElem.find(".bb-chart-lines .bb-circle-" + idx).attr("r", 3);
                    } else {
                        graphInstance.revert();
                    }
                }
            });
            this._setActiveLayerRollover(null, graph);
        }
    };

    _onGraphDataClick(d, element, graph) {
        if (graph.activeLayer) {
            var xDataValue = graph.categories()[d.x];
            var dataQuery = new DataQuery([graph.activeLayer.featureNameDataColumn]);
            //dataQuery.searchCriteria = xDataValue; //peut générer des erreurs
            dataQuery.execute(function(queryResult) {
                var linkingIds = _.reduce(queryResult.values[graph.activeLayer.featureNameDataColumn.dataTable.id][graph.activeLayer.featureNameDataColumn.id], function(linkingIds, value, idx) {
                    if (value === xDataValue) {
                        linkingIds.push(queryResult.linkingIds[idx]);
                    }
                    return linkingIds;
                }, []);
                graph.activeLayer.getSimpleFeatures(linkingIds, function(result) {
                    this._mapController.zoomOnFeatures(result.features, graph.activeLayer);
                }, this);
            }, this);
        }
    };

    _onGraphLegendOver(id, graph) {
        _.forEach(bb.instance, function(graphInstance) {
            var $graphInstanceElem = $(graphInstance.element);
            if ($graphInstanceElem.is(":visible")) {
                if (graph.config("data.type") == "line" && graphInstance.config("data.type") != "line") {
                    var idx = graphInstance.categories().indexOf(id);
                    $graphInstanceElem.find(".bb-chart-bars .bb-shape:not(.bb-shape-" + idx + ")").css("fill-opacity", 0.1);
                } else {
                    graphInstance.focus(id);
                }
            }
        });
        this._setActiveLayerRollover(id, graph);
    };

    _onGraphLegendOut(id, graph) {
        _.forEach(bb.instance, function(graphInstance) {
            var $graphInstanceElem = $(graphInstance.element);
            if ($graphInstanceElem.is(":visible")) {
                if (graph.config("data.type") == "line" && graphInstance.config("data.type") != "line") {
                    $graphInstanceElem.find(".bb-chart-bars .bb-shape").css("fill-opacity", 1);
                } else {
                    graphInstance.revert();
                }
            }
        });
        this._setActiveLayerRollover(null, graph);
    };

    _onGraphLegendClick(id, graph, graphConfig) {
        graph.toggle(id);
        if (graphConfig.DATA_AUTO_SORT) {
            setTimeout(function() {
                var shown = graph.data.shown();
                if (shown.length) {
                    var sortByRowIdx = _.findIndex(graph.graphData, {"0": shown[0].id}),
                        sortedData = this._sortGraphData(graph.graphData, graphConfig.DATA_AUTO_SORT, sortByRowIdx);
                    graph.load({
                        "columns": graphConfig.GRAPH_DATA_ORIENTATION == "columns" ? sortedData : undefined,
                        "rows": graphConfig.GRAPH_DATA_ORIENTATION == "rows" ? sortedData : undefined,
                        "categories": _.tail(sortedData[0])
                    });
                }
            }.bind(this), 0);
        }
    };

    _setActiveLayerRollover(id, graph) {
        if (graph.activeLayer) {
            if (id) {
                //add focus feature to rollover on map
                var dataQuery = new DataQuery([graph.activeLayer.featureNameDataColumn]);
                //dataQuery.searchCriteria = id; //peut générer des erreurs
                dataQuery.execute(function(queryResult) {
                    var linkingIds = _.reduce(queryResult.values[graph.activeLayer.featureNameDataColumn.dataTable.id][graph.activeLayer.featureNameDataColumn.id], function(linkingIds, value, idx) {
                        if (value === id) {
                            linkingIds.push(queryResult.linkingIds[idx]);
                        }
                        return linkingIds;
                    }, []);
                    graph.activeLayer.getSimpleFeatures(linkingIds, function(result) {
                        graph.activeLayer.rolloverFeatures = result.features;
                    }, this);
                }, this);
            } else {
                //remove rollover
                graph.activeLayer._rolloverFeatures = [];
            }
        }
    };

    _onPrintBtnClicked(evt) {
        var $printedPanel = $(evt.target).closest(".BbGraphs_panel_container"),
            panelId = $printedPanel.attr("data-panel"),
            elemsToPrint = $printedPanel.find(".BbGraphs_printable:visible").get(),
            filename = this._map.activeThemeSet.title,
            printOption = this._activeGraphsConfig[panelId].PRINT_OPTIONS;
        exportToPDF(elemsToPrint, filename, printOption);
    };

    _addSplittersResizeListeners() {
        var onSplitterResized = _.debounce(function(evt) {
            _.forEach(bb.instance, function(graphInstance) {
                if (graphInstance.$panelContainer.is(":visible") && (graphInstance.config("size.height") != graphInstance.graphConfig.HEIGHT_FN() || graphInstance.config("size.width") != graphInstance.graphConfig.WIDTH_FN())) {
                    graphInstance.resize({
                        "height": graphInstance.graphConfig.HEIGHT_FN(),
                        "width": graphInstance.graphConfig.WIDTH_FN()
                    });
                }
            });
        }, 0);

        if (typeof $(".cv-horizontal-splitter").data("kendoSplitter") != "undefined") $(".cv-horizontal-splitter").data("kendoSplitter").bind("resize", onSplitterResized);
        if (typeof $(".cv-right-vertical-splitter").data("kendoSplitter") != "undefined") $(".cv-right-vertical-splitter").data("kendoSplitter").bind("resize", onSplitterResized);
        if (typeof $(".cv-left-vertical-splitter").data("kendoSplitter") != "undefined") $(".cv-left-vertical-splitter").data("kendoSplitter").bind("resize", onSplitterResized);
    };

  }
